import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const client = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
});

// --------------------
// GENERIC API
// --------------------

export const api = {
  get: (url) => client.get(url),

  post: (url, body) => client.post(url, body),

  put: (url, body) => client.put(url, body),

  del: (url) => client.delete(url),
};

// --------------------
// AUTH API
// --------------------

export const auth = {
  login: (data) => api.post("/auth/login", data),

  logout: () => api.post("/auth/logout"),

  me: () => api.get("/auth/me"),
};

// --------------------
// PUBLIC API
// --------------------

export const publicApi = {
  getMenu: () => api.get("/menu"),

  getCategories: () => api.get("/menu/categories"),

  getSettings: () => api.get("/settings"),

  getMenuByCategory: (id) =>
    api.get(`/menu/category/${id}`),
};

// --------------------
// ADMIN API
// --------------------

export const adminApi = {
  createMenuItem: (data) =>
    api.post("/admin/menu", data),

  updateMenuItem: (id, data) =>
    api.put(`/admin/menu/${id}`, data),

  deleteMenuItem: (id) =>
    api.del(`/admin/menu/${id}`),

  uploadCategoryImage: (id, field, formData) =>
    api.post(`/admin/categories/${id}/upload-image?field=${field}`, formData),

  updateCategory: (id, data) =>
    api.put(`/admin/categories/${id}`, data),

  updateSettings: (data) =>
    api.put("/admin/settings", data),
};

export default client;